export default baseType => ({
  [baseType]: baseType,
  [`${baseType}_FULFILLED`]: `${baseType}_FULFILLED`,
  [`${baseType}_REJECTED`]: `${baseType}_REJECTED`,
  [`CLEAR_${baseType}`]: `CLEAR_${baseType}`
})
